import { validateCoordinate } from '@collector/shared-ui-domain'

/**
 * Transform 100 ordinal numbers: 1, 2, (...), 100
 * into 100 doubles: 0, 1.01, (...), 100
 */
export function mapCoordinateToDouble(coordinate: number): number {
  validateCoordinate(coordinate)

  const scale = 100 / 99
  const result = (coordinate - 1) * scale

  return Math.round(result * 1000) / 1000 // 3 decimal places
}
